<template>
    <div class="table-listing-rows-wrapper">
        <b-row
            :class="tableHeaderClass"
            align-v="end"
        >
            <template v-for="(cell, index) in cells">
                <b-col
                        :class="tableHeaderCellClass + ' ' + cellClass(cell,'inline-flex')"
                        v-if="cell.header"
                        :key="cell.header ? cell.header : `loading-column-${index}`"
                        :cols="cell.headerColSize ? cell.headerColSize : cell.colSize"
                        class="cell"
                        :sm="cellColSm(cell)"
                        :md="cellColMd(cell)"
                        :lg="cellColLg(cell)"
                >
                    <div>
                        {{ cell.header }}
                    </div>
                </b-col>
            </template>
        </b-row>
        <b-row
                v-for="(item, index) in loadingItems"
                :key="'loadingItem-' + index"
                :class="tableRowClass"
                class="item-row"
        >
            <b-col
                    v-for="(cell, cellIndex) in cells"
                    :key="cell.header ? cell.header : `loading-column-${cellIndex}`"
                    :cols="cell.colSize"
                    :sm="cellColSm(cell)"
                    :md="cellColMd(cell)"
                    :lg="cellColLg(cell)"
                    class="cell"
                    :class="cellClass(cell)"
            >
                <component
                        v-if="!isSlotCell(cell) || (isSlotCell(cell) && !cell.config.hasOwnProperty('loadingSlotName'))"
                        :is="cell.vueComponent()"
                        v-bind="cell.props()"
                        :is-loading="true"
                />
                <slot
                    v-else
                    :name="cell.config.loadingSlotName"
                ></slot>
            </b-col>
        </b-row>
    </div>
</template>
<script>

    import get from "lodash/get";
    import SlotCellLoader from './CellTypes/SlotCell/SlotCellLoader';

    export default {
        name: 'LoadingResourceListingTable',
        props: {
            pageSize: {
                type: Number,
                requires: true,
            },
            cells: {
                type: Array,
                required: true,
            },
            tableRowClass:{
                type: String,
                default: 'border-bottom py-3 d-flex align-items-center'
            },
            tableHeaderClass:{
                type: String,
                default: 'border-bottom border-left border-right d-flex align-items-center'
            },
            tableHeaderCellClass:{
                type: String,
                required: true
            },
        },
        computed: {
            loadingItems: function () {
                const items = [];
                for (let i = 0; i < this.pageSize; i++) {
                    items.push({});
                }
                return items;
            }
        },
        methods: {
            cellColSm(cell) {
                return get(cell.responsiveCols, 'sm', cell.colSize)
            },

            cellColMd(cell) {
                return get(cell.responsiveCols, 'md', this.cellColSm(cell))
            },

            cellColLg(cell) {
                return get(cell.responsiveCols, 'lg', this.cellColMd(cell));
            },

            cellClass(cell, displayType= 'block') {
                let cellClass = '';

                let showXs = !!cell.colSize;

                cellClass += showXs ? `d-${displayType} ` : 'd-none ';
                cellClass += this.cellColSm(cell) ?  `d-sm-${displayType} ` : 'd-sm-none ';
                cellClass += this.cellColMd(cell) ?  `d-md-${displayType} ` : `d-md-none d-lg-${displayType} `;

                return cellClass
            },

            isSlotCell(cell){
                return cell instanceof SlotCellLoader;
            }
        }
    };
</script>
